export function dashboardPendingPayrollsItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-item-template-pending-payrolls.html";
    const html = /*html*/`<apex-dashboard-pending-payrolls-container></apex-dashboard-pending-payrolls-container>`;
    $templateCache.put(path, html);
}

export function dashboardPendingPayrollsListItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-list-item-template-pending-payrolls.html";
    const html = /*html*/`
        <p ng-if="!dashboard.count === 0">No payrolls are pending at this time.</p>
        <p ng-if="dashboard.count > 0">Some payrolls are approaching the deadline and are still pending submission.</p>
    `;
    $templateCache.put(path, html);
}
